import { useEffect, useState } from 'react';

/* Live countdown to a mastery-check unlock (the engine's checkLockUntil /
   current_action.until). One component, used in two places: the session's
   "check locked" terminal card and the domain page's action card. Shows the
   remaining time ticking down plus the exact local unlock moment; once the
   moment passes it flips to an "open now" chip so a student staring at the
   screen sees it unlock live. */
export default function CheckLockTimer({ until, className = '' }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const t = new Date(until || '').getTime();
  if (!Number.isFinite(t)) return null;

  const ms = t - now;
  if (ms <= 0) {
    return (
      <div className={`inline-flex items-center gap-2 rounded-full border border-success-200 bg-success-50/60 px-3.5 py-1.5 text-[13px] font-bold text-success-700 ${className}`}>
        <span aria-hidden>🔓</span> The skill check is open now
      </div>
    );
  }
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const count = d > 0 ? `${d}d ${h}h ${m}m` : h > 0 ? `${h}h ${m}m ${sec}s` : `${m}m ${sec}s`;
  const when = new Date(t).toLocaleString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
  return (
    <div className={`inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-3.5 py-1.5 text-[13px] text-amber-800 ${className}`}>
      <span aria-hidden>🔒</span>
      <span>
        Unlocks in <span className="font-extrabold tabular-nums">{count}</span>
        <span className="text-amber-700/80"> · {when}</span>
      </span>
    </div>
  );
}
